export default "__VITE_ASSET__Oc6Vju0___"